import { z } from "zod";

export const payrollSchema = z.object({
  // Employee details
  month: z.string().min(1, "Month is required"),
  year: z.string().min(1, "Year is required"),
  name: z.string().min(1, "Employee name is required"),
  designation: z.string().min(1, "Designation is required"),
  department: z.string().min(1, "Department is required"),
  employee_id: z.coerce.number().min(1, "Employee ID is required"),
  employee_code: z.string().min(1, "Employee Code is required"),

  grossSalary: z.coerce.number().min(0, "Gross Salary must be non-negative"),
  basic: z.coerce.number().min(0, "Basic must be non-negative"),
  hra: z.coerce.number().min(0, "HRA must be non-negative"),
  special_allowance: z.coerce
    .number()
    .min(0, "Special allowance must be non-negative"),
  statutory_bonus: z.coerce
    .number()
    .min(0, "Statutory bonus must be non-negative"),
  misc_allowance: z.coerce
    .number()
    .min(0, "Misc allowance must be non-negative"),
  incentives: z.coerce.number().min(0, "Incentives must be non-negative"),
  esic_uan: z.string().min(1, "UAN Number is required"),
  pf: z.coerce.number().min(0, "PF must be non-negative"),
  esic: z.coerce.number().min(0, "ESIC must be non-negative"),
  ap_tax: z.coerce.number().min(0, "AP Tax must be non-negative"),
  net_salary: z.coerce.number().min(0, "Net Salary"),
  health_deduction: z.coerce
    .number()
    .min(0, "Health Deduction must be non-negative"),
  other_deductions: z.coerce
    .number()
    .min(0, "Other Deductions must be non-negative"),
  lop_deduction: z.coerce.number().min(0, "Can't be negative"),

  bank_name: z.string().min(1, "Bank name is required"),
  ac_number: z.string().min(5, "Account number must be valid"),
  ifsc_code: z.string().regex(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code"),
  branch: z.string().min(1, "Branch is required"),
  pan: z.string().regex(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN"),
  date_of_joining: z.string().min(1, "Date of Joining is required"),
  pf_acc_number: z.string().min(1, "P.F. A/C Number is required"),
  uan_number: z.string().min(1, "UAN Number is required"),
  days_worked: z.coerce.number().min(0, "Days Worked must be non-negative"),
  lop: z.coerce.number().min(0, "LOP must be non-negative"),
  pay_date: z.string().min(1, "Pay Date is required"),
  travel_allowances: z.coerce
    .number()
    .min(0, "Travel Allowance must be non-negative"),
  otherEarnings: z.coerce
    .number()
    .min(0, "Other Earnings must be non-negative"),
  incomeTaxDeduction: z.coerce
    .number()
    .min(0, "Income Tax Deduction must be non-negative"),
  reimbursementTravel: z.coerce
    .number()
    .min(0, "Reimbursement (Travel) must be non-negative"),
  reimbursementOthers: z.coerce
    .number()
    .min(0, "Reimbursement (Others) must be non-negative"),
  totalNetPayableWords: z
    .string()
    .min(1, "Total Net Payable (in words) is required"),
});

export type PayrollFormData = z.infer<typeof payrollSchema>;
